import React, { Component } from 'react'
import moment from 'moment'
// import Dates from './Dates'
import dynamic from "next/dynamic";
import { Select, Space, TimePicker } from 'antd';
import DatePickerCon from '$Deposits/Components/Components/DatePicker'
// import locale from "antd/lib/locale/th_TH";
import 'moment/locale/th';
moment.locale('th', {
    //月份
    monthsShort: [
        "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
        "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
    ],
});
const DatePicker = dynamic(import("antd/lib/date-picker"), {
    loading: () => (
        <div className="ant-skeleton ant-skeleton-with-avatar ant-skeleton-active">
            <div className="ant-skeleton-content">
                <ul className="ant-skeleton-paragraph">
                    <li></li>
                </ul>
            </div>
        </div>
    ),
});
export default class Dates extends Component {


    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        }
    }

    componentDidMount() {
        
    }

    disabledDate = (value) => {
        return (
            value && value.valueOf() > new Date().getTime()
        );
    }

    render() {
        const { mode, titleText } = this.props
        return (
            
            <>
                <DatePickerCon
                    mode={mode}
                    DatePicker={(propCon) => {
                        const {
                            minDate = moment(new Date('1940-01-01'))._d,
                            maxDate = moment(new Date())._d,
                            onChange,
                            defaults,
                        } = propCon
                        return (
                            <>
                                <div className='depositDatePicker'>
                                    {/* <span>{mode == 'time' ? defaults : moment(defaults).format('DD-MM-YYYY')}</span>
                                    <span className={mode == 'date' ? 'dateIcon' : 'timeIcon'} /> */}
                                    
                                    {mode == 'date' &&
                                        <div className='date-picker-container'>
                                            <DatePicker
                                                size="large"
                                                showToday={false}
                                                allowClear={false}
                                                defaultValue={moment(defaults)}
                                                style={{ width: "100%" }}
                                                format="DD/MM/YYYY"
                                                suffixIcon={<span className={'dateIcon'} />}
                                                onChange={(date, dateString) => {
                                                    const formattedDate = date.format("YYYY-MM-DD");// 转换为目标格式 "YYYY-DD-MM"
                                                    onChange(formattedDate);
                                                }}
                                                dropdownClassName="deposit-date-picker-container"
                                                getCalendarContainer={(trigger) => trigger.parentElement}
                                                disabledDate={this.disabledDate}
                                                // locale={locale}
                                            />
                                        </div>
                                    }
                                    
                                    {mode == 'time' &&
                                        <div className='time-picker-container'>
                                            <TimePicker
                                                size="large"
                                                showToday={false}
                                                allowClear={false}
                                                style={{ width: "100%" }}
                                                value={defaults === 'NOT_SET' ? null : moment(defaults, 'HH:mm')} // 讓 NOT_SET 顯示 placeholder
                                                format={'HH:mm'}
                                                placeholder="ชั่วโมง:นาที"
                                                suffixIcon={<span className={'timeIcon'} />}
                                                onChange={(e, dateString) => { onChange(dateString) }}
                                                getPopupContainer={(trigger) => trigger.parentElement}
                                                popupClassName="deposit-time-picker-container"
                                            />
                                        </div>
                                    }
                                </div>
                            </>
                        )
                    }}

                />

            </>

        )
    }


}
